import { render, staticRenderFns } from "./NewsletterForm.vue?vue&type=template&id=b2a24e0c&scoped=true"
import script from "./NewsletterForm.vue?vue&type=script&lang=ts"
export * from "./NewsletterForm.vue?vue&type=script&lang=ts"
import style0 from "./NewsletterForm.vue?vue&type=style&index=0&id=b2a24e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a24e0c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsFormResponse: require('/usr/src/nuxt-app/components/elements/FormResponse.vue').default,ElementsInputWithValidation: require('/usr/src/nuxt-app/components/elements/InputWithValidation.vue').default,ElementsPrivacyCheckbox: require('/usr/src/nuxt-app/components/elements/PrivacyCheckbox.vue').default})
